/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * In-app notification preferences
 * @export
 * @interface NotificationSettingsSettingsInApp
 */
export interface NotificationSettingsSettingsInApp {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsInApp
     */
    claim?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsInApp
     */
    document?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsInApp
     */
    comparison?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsInApp
     */
    task?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsInApp
     */
    supplement?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsInApp
     */
    note?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsSettingsInApp
     */
    email?: boolean;
}

/**
 * Check if a given object implements the NotificationSettingsSettingsInApp interface.
 */
export function instanceOfNotificationSettingsSettingsInApp(value: object): value is NotificationSettingsSettingsInApp {
    return true;
}

export function NotificationSettingsSettingsInAppFromJSON(json: any): NotificationSettingsSettingsInApp {
    return NotificationSettingsSettingsInAppFromJSONTyped(json, false);
}

export function NotificationSettingsSettingsInAppFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationSettingsSettingsInApp {
    if (json == null) {
        return json;
    }
    return {
        
        'claim': json['claim'] == null ? undefined : json['claim'],
        'document': json['document'] == null ? undefined : json['document'],
        'comparison': json['comparison'] == null ? undefined : json['comparison'],
        'task': json['task'] == null ? undefined : json['task'],
        'supplement': json['supplement'] == null ? undefined : json['supplement'],
        'note': json['note'] == null ? undefined : json['note'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function NotificationSettingsSettingsInAppToJSON(json: any): NotificationSettingsSettingsInApp {
    return NotificationSettingsSettingsInAppToJSONTyped(json, false);
}

export function NotificationSettingsSettingsInAppToJSONTyped(value?: NotificationSettingsSettingsInApp | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim': value['claim'],
        'document': value['document'],
        'comparison': value['comparison'],
        'task': value['task'],
        'supplement': value['supplement'],
        'note': value['note'],
        'email': value['email'],
    };
}

